import { render, staticRenderFns } from "./PText.vue?vue&type=template&id=629c5d52"
import script from "./PText.vue?vue&type=script&lang=js"
export * from "./PText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports